// extracted by css-extract-rspack-plugin
export default {"footnote":"wJgVjfPEu2IctAub","footnote_none":"vMlQORaMdQQ_8yMQ"};